import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import AuthLayout from "@/components/AuthLayout";

export default function Register() {
  return (
    <AuthLayout
      icon={Mail}
      title="Invitation only"
      subtitle="InclusiveCore accounts are created by invitation"
      footer={
        <>
          Already have an account?{" "}
          <Link to="/login" className="text-primary font-medium hover:underline">
            Log in
          </Link>
        </>
      }
    >
      <p className="text-sm text-foreground">
        This platform doesn't have open sign-up. If your organisation has invited you, open the
        link in your invitation email to create your account.
      </p>
      <p className="text-sm text-muted-foreground mt-4">
        If you don't have an invitation, ask your organisation's InclusiveCore administrator to
        send you one.
      </p>
      <div className="mt-6 pt-6 border-t border-border text-sm text-center space-y-2">
        <p>
          <Link to="/login" className="text-primary font-medium hover:underline">
            Go to sign in
          </Link>
        </p>
        <p>
          <Link to="/forgot-password" className="text-primary font-medium hover:underline">
            Forgot your password?
          </Link>
        </p>
      </div>
    </AuthLayout>
  );
}
